<a
  mat-list-item
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  class="data-sync-trigger"
  [class.mini]="!isExpanded()"
  [class.highlighted]="activeJobs().length > 0 && !disabled()"
  [disabled]="disabled()"
  [matTooltip]="tooltip()"
  [matTooltipDisabled]="!tooltip()"
  matTooltipPosition="right"
  (mouseenter)="scheduleOpen()"
  (mouseleave)="scheduleClose()">
  <mat-icon matListItemIcon [tfsIcon]="'arrows-clockwise'"></mat-icon>
  @if (isExpanded()) {
    <span>Data sync</span>
  }
</a>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'bottom', offsetX: 8 },
  ]">
  <div (mouseenter)="keepOpen()" (mouseleave)="onPanelLeave($event)">
    <tfs-data-sync-panel [activeJobs]="activeJobs()" [completedJobs]="completedJobs()" />
  </div>
</ng-template>
